import { Checkbox } from "antd";
import { useDrag, useDrop } from "react-dnd";
import clsx from "clsx";
type PropsType = {
  id: string;
  text: string;
  index: number;
  onDragMove: (dragIndex: number, hoverIndex: number) => void;
  canDrag: boolean;
  onCheck: () => void;
  disabled?: boolean;
};
export default function DraggableButton({
  id,
  text,
  index,
  onDragMove,
  canDrag,
  onCheck,
  disabled = false,
}: PropsType) {
  const [{ isDragging }, drag] = useDrag({
    type: "button",
    item: { id, index, canDrag },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: "button",
    hover: (draggedItem) => {
      const item = draggedItem as {
        id: string;
        index: number;
      };

      if (item.index !== index) {
        onDragMove(item.index, index);
        item.index = index;
      }
    },
  });

  return (
    <button
      className={clsx(
        "py-2 px-4 rounded-full border flex items-center justify-between gap-2",
        canDrag
          ? "border-[#3E83F6] bg-[#DCE7FD]"
          : "border-[#BDBDBD] bg-[#eeeeee]  hover:bg-[#e6edfc]",
      )}
      style={{
        opacity: isDragging ? 0 : 1,
        cursor: "move",
        userSelect: "none",
      }}
      ref={(node) => drag(drop(node))}
      onClick={() => onCheck}
    >
      <Checkbox onChange={onCheck} checked={canDrag} disabled={disabled} />
      {text}
    </button>
  );
}
